import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { UserService } from '../services/user.service'
import { IndustryService } from '../services/industry.service'
import { PagerService } from '../services/pagination.service'

import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-providers',
    templateUrl: './providers.component.html',
    animations: [fadeInUp]
})
export class ProvidersPageComponent implements OnInit, OnDestroy {
    isLoggedIn: Boolean = false
    loginRedirectPath: String = ''

    industrySlug: any
    industry: any
    industries: any
    careerSlug: any
    career: any
    courseSlug: any
    course: any
    providers: any
    storedProviders: any
    pager: any = {}
    pagedItems: any
	searchProviderTimeout: any
	searchProviderValue: String = ''
	filterOptions: Array<any> = ['Most Reviewed', 'Top Rated (Student or Graduate)', 'Top Rated (Employer)', 'A-Z']
    industriesSubscription: any
    providersSubscription: any
    paramsSubscription: any
    offset: number = 0
    limit: number = 20

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private industryService: IndustryService,
        private title: Title,
        private pagerService: PagerService
    ) {
        this.isLoggedIn = this.userService.isLoggedin()

        this.paramsSubscription = this.route.params.subscribe(params => {
            const industry = params.industry
            const career = params.career
            const course = params.course

            let courseTitle = this.industryService.getTitleString(course)
            let careerTitle = this.industryService.getTitleString(career)

            const title = courseTitle + ' | ' + careerTitle

            this.title.setTitle(title)
        })
    }

    ngOnInit() {
        this.industrySlug = this.route.snapshot.params['industry']
        this.careerSlug = this.route.snapshot.params['career']
        this.courseSlug = this.route.snapshot.params['course']

        this.industryService.getIndustries()
        this.industriesSubscription = this.industryService.Industries.subscribe(industries => {
            if (industries && industries.length > 0) {
				this.industries = industries.filter(elm => {
					if (elm.slug === this.industrySlug) {
						this.industry = elm
						return false
					} else {
						return true
					}
				})

				// Shuffle array
				this.industries = this.industries.sort(() => 0.5 - Math.random());
				// Get sub-array of first n elements after shuffled
				this.industries = this.industries.slice(0, 2);
            }
        })

        this.industryService.getCareerBySlug(this.careerSlug).subscribe(career => {
            this.career = career.json()
        }, err => {
            console.log(err);
        })

        this.industryService.getCourseBySlug(this.courseSlug).subscribe(course => {
            this.course = course.json()
            this.getProviders()
        }, err => {
            console.log(err);
        })
    }

    ngOnDestroy() {
        if (this.industriesSubscription) {
            this.industriesSubscription.unsubscribe()
        }
        if (this.providersSubscription) {
            this.providersSubscription.unsubscribe()
        }
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe()
        }
    }

    getProviders() {
        this.providersSubscription = this.industryService.getProvidersByCourseId(this.course['_id']).subscribe(providers => {
            let tempProviders = providers.json()
            this.providers = tempProviders
            // initially sort providers from A-Z
            this.providers.sort((a, b) => {
                let returnVal = 0
                if (a.name < b.name) returnVal = -1;
                if (a.name > b.name) returnVal = 1;
                return returnVal;
            })
			this.storedProviders = this.providers
            this.filterSelect()
            this.getLocation()
            this.findAll(0, this.limit)
        }, err => {
            console.log(err);
        })
    }

    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (!this.filterOptions.includes('Closest to me')) {
                    this.filterOptions.push('Closest to me')
                }
                this.providers = this.providers.map(item => {
                    const newItem = item
                    if (item.location && item.location.Latitude && item.location.Longitude) {
                        newItem.distance = this.calcDistance(position.coords.latitude, position.coords.longitude, item.location.Latitude, item.location.Longitude)
                    }
                    return newItem
                });
            });
        }
    }

    calcDistance(lat1, lon1, lat2, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            let radlat1 = Math.PI * lat1 / 180;
            let radlat2 = Math.PI * lat2 / 180;
            let theta = lon1 - lon2;
            let radtheta = Math.PI * theta / 180;
            let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            dist = dist * 1.609344
            return dist.toFixed(0);
        }
    }

    filterSelect(val = null) {
        if (val) {
            val = val.target.value
        } else {
            val = 'Most Reviewed'
        }
		this.storedProviders.sort((a, b) => {
            let returnVal = 0
            if (val === 'A-Z') {
                if (a.name < b.name) returnVal = -1;
                if (a.name > b.name) returnVal = 1;
			} else if (val === 'Top Rated (Student or Graduate)') {
                if (a.reviewCount.student < b.reviewCount.student) returnVal = 1;
                if (a.reviewCount.student > b.reviewCount.student) returnVal = -1;
            } else if (val === 'Top Rated (Employer)') {
                if (a.reviewCount.employer < b.reviewCount.employer) returnVal = 1;
                if (a.reviewCount.employer > b.reviewCount.employer) returnVal = -1;
            } else if (val === 'Closest to me') {
                if (Number(a.distance) < Number(b.distance)) returnVal = -1;
                if (Number(a.distance) > Number(b.distance)) returnVal = 1;
            } else if (val === 'Most Reviewed') {
                if (a.reviewCount.total < b.reviewCount.total) returnVal = 1;
                if (a.reviewCount.total > b.reviewCount.total) returnVal = -1;
            }
            return returnVal;
        })
		this.providers = this.storedProviders
		if (this.searchProviderValue !== '') {
			this.findSearchedProvider(this.searchProviderValue)
		} else {
			this.offset = 0
			this.findAll(this.offset, this.limit)
		}
    }

	findSearchedProvider(value) {
		clearTimeout(this.searchProviderTimeout);
		this.searchProviderTimeout = setTimeout(() => {
			this.searchProviderValue = value.toLowerCase()
			this.providers = this.storedProviders.filter((item) => {
				let name = item.name.toLowerCase()
				if (name.includes(this.searchProviderValue)) {
					return name
				} else {
					return
				}
			});
			this.offset = 0
			if (this.searchProviderValue !== '') {
				this.limit = 1000
			} else {
				this.limit = 20
			}
			this.findAll(this.offset, this.limit)
		}, 600)
	}

    seeAllReviews(provider: String) {
        if (this.isLoggedIn) {
            this.router.navigate([this.router.url + '/' + provider])
        } else {
            this.loginRedirectPath = this.router.url + '/' + provider
            setTimeout(function () {
                document.getElementById('notloggedin-overlay').classList.add('is-block')
            }, 10)
            setTimeout(function () {
                document.getElementById('notloggedin-overlay').classList.add('is-visible')
            }, 20)
        }
    }

    closeOverlay() {
        document.getElementById('notloggedin-overlay').classList.remove('is-visible')
        setTimeout(function () {
            document.getElementById('notloggedin-overlay').classList.remove('is-block')
        }, 500)
    }

    onPageChange(offset) {
		this.offset = offset
        this.findAll(this.offset, this.limit)
        let elems = document.getElementsByClassName('c-course__code') as HTMLCollectionOf<HTMLElement>
        if (elems) {
            let scrollX = elems[0].offsetLeft
            let scrollY = elems[0].offsetTop + 850
            window.scrollTo(scrollX, scrollY)
        }
    }

    findAll(offset: number, limit: number) {
		let startIndex = offset
		let endIndex = Math.min(startIndex + limit - 1, this.providers.length - 1)
		this.pagedItems = this.providers.slice(startIndex, endIndex + 1)
	}

}



// WEBPACK FOOTER //
// ./src/app/industries/providers.component.ts